import http from '../http-common'

class StreamSeatService {
  getRecordById (streamId) {
    return http.get(`/api/live-editor/get-record-by-id/${streamId}`)
  }

  createRecord (data) {
    return http.post('/api/live-editor/create-record', data)
  }

  createPreview(data) {
    return http.post('/api/live-editor/create-preview', data)
  }

  cancelRecord (id) {
    return http.put(`/api/live-editor/cancel-record/${id}`)
  }
  publishRecord (id) {
    return http.put(`/api/live-editor/publish-record/${id}`)
  }
  //
  // getDownloadProgress (streamVideoId) {
  //   return http.get(`/api/live-editor/get-download-progress/${streamVideoId}`)
  // }
  //
  // setOptions (streamVideoId, data) {
  //   return http.put(`/api/live-editor/set-options/${streamVideoId}`, data)
  // }
  //
  // cancelRecord (streamVideoId) {
  //   return http.put(`/api/live-editor/cancel-record/${streamVideoId}`)
  // }
  //
  // deleteRecord (streamVideoId) {
  //   return http.delete(`/api/live-editor/delete-record/${streamVideoId}`)
  // }
  //
  // publishRecord (recordId) {
  //   return http.put(`/api/live-editor/publish-record/${recordId}`)
  // }
  //
  // isRecordValid (recordId) {
  //   return http.get(`/api/live-editor/check-record-validation/${recordId}`)
  // }
}

export default new StreamSeatService()
